import { WorkflowTemplateGetDTO } from '@library/dto/workflow/workflow-template.dto';
import { SERVER_API_URL } from '@one/app/app.constants';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkflowTemplateService {
  public readonly _httpClient = inject(HttpClient);

  private readonly _resource = `api/workflows`;
  private readonly _resourceUrl = `${SERVER_API_URL}${this._resource}`;

  public getWorkflowTemplate$(workflowId: Readonly<number>): Observable<WorkflowTemplateGetDTO> {
    const url = `${this._resourceUrl}/${workflowId}`;

    return this._httpClient.get<WorkflowTemplateGetDTO>(url, { observe: 'body' });
  }
}
